import {lazy} from "react";

export const ReportExecutionSingleVoyageLazy = lazy(() => import('./ReportExecutionSingleVoyage'))